// Mini Boss — small progressive enhancements for the mini-boss-* sections.
(() => {
  document.documentElement.classList.add('mb-js');

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Scroll reveal
  const revealAll = (root = document) => {
    const items = root.querySelectorAll('[data-mb-reveal]:not(.is-visible)');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    items.forEach((el) => io.observe(el));
  };

  // Flip card (front / back of the tee)
  const initFlips = (root = document) => {
    root.querySelectorAll('[data-mb-flip]:not([data-mb-ready])').forEach((card) => {
      card.setAttribute('data-mb-ready', '');
      const toggle = () => {
        const flipped = card.classList.toggle('is-flipped');
        card.setAttribute('aria-pressed', String(flipped));
      };
      card.addEventListener('click', toggle);
      card.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle();
        }
      });
    });
  };

  // Product showcase form: playful feedback + sticky mobile bar
  const initShowcase = (root = document) => {
    root.querySelectorAll('[data-mb-showcase]:not([data-mb-ready])').forEach((section) => {
      section.setAttribute('data-mb-ready', '');
      const form = section.querySelector('form[data-mb-form]');
      const button = form?.querySelector('[data-mb-add]');
      const sticky = section.querySelector('[data-mb-sticky]');

      form?.addEventListener('submit', () => {
        if (!button) return;
        button.querySelector('[data-mb-add-label]').textContent = button.dataset.successLabel;
        button.classList.add('is-done');
      });

      if (sticky && 'IntersectionObserver' in window && button) {
        const io = new IntersectionObserver(
          ([entry]) => {
            const above = entry.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', !entry.isIntersecting && above);
          },
          { threshold: 0 }
        );
        io.observe(button);
      }
    });
  };

  const init = (root) => {
    revealAll(root);
    initFlips(root);
    initShowcase(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
